import PropTypes from "prop-types";
import styled from "styled-components";

const StyledCredit = styled.div`
  border: 1px solid #ffbd14;
  border-radius: 7px;
  padding: 0.25rem 0.75rem;
  margin: 0 -0.75rem 0.75rem;
`;

/**
 * Displays order summary total including credits and debits.
 *
 * @param {Object} props
 * @param {Object} props.orderSummaryDetails
 * @param {Boolean} props.redeemingGift
 * @param {Boolean} props.totalOnly
 */
const CheckoutOrderFees = ({
  orderSummaryDetails,
  totalOnly,
  redeemingGift,
}) => {
  const total = orderSummaryDetails.charge || orderSummaryDetails.total;

  return (
    <div>
      {!totalOnly && (
        <>
          <div className="flex justify-between my-2 text-textGray-darker text-sm">
            <div className="pr-3">Subtotal</div>
            <div>{redeemingGift ? "$0" : orderSummaryDetails?.item?.value}</div>
          </div>
          <div className="flex justify-between my-2 text-textGray-darker text-sm">
            <div className="pr-3">Shipping</div>
            <div>Free</div>
          </div>
          {orderSummaryDetails.tax ? (
            <div className="flex justify-between my-2 text-textGray-darker text-sm">
              <div className="pr-3">{orderSummaryDetails.tax.label}</div>
              <div>{orderSummaryDetails.tax.value}</div>
            </div>
          ) : null}
          {!redeemingGift && orderSummaryDetails.coupon ? (
            <div className="flex justify-between my-2 text-textGray-darker text-sm">
              <div className="pr-3">{orderSummaryDetails.coupon.label}</div>
              <div>{orderSummaryDetails.coupon.value}</div>
            </div>
          ) : null}
          {!redeemingGift && orderSummaryDetails.credit ? (
            <StyledCredit className="credit flex justify-between my-2 text-textGray-darker text-sm border-">
              <div className="pr-3">Available credit applied</div>
              <div>{orderSummaryDetails.credit.value}</div>
            </StyledCredit>
          ) : null}
        </>
      )}
      <div className="flex justify-between my-2 text-black font-medium">
        <div className="pr-3">Today&apos;s Total</div>
        <div>{redeemingGift ? "$0" : total?.value}</div>
      </div>
    </div>
  );
};

CheckoutOrderFees.propTypes = {
  orderSummaryDetails: PropTypes.object,
  redeemingGift: PropTypes.bool,
  totalOnly: PropTypes.bool,
};

export default CheckoutOrderFees;
